import { AgmMap } from '@agm/core';
import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { sweetAlert } from 'src/app/utils/swal';
import { timeCalculation } from '../../../utils/utils.common';
import { KpisService } from '../../../service/kpis-service/kpis.service';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { environment } from 'src/environments/environment';
import { ServiceAreasService } from '../../../service/service-areas-service/service-areas.service';
import { LevelOfServiceService } from '../../../service/level-of-service/level-of-service.service';
import { AssigTripsService } from 'src/app/service/assigntrips-service/assigntrips-service';
import { CorporateService } from 'src/app/service/corporate-service/corporate-service';
import { DriversService } from 'src/app/service/drivers-service/drivers-service';
import { PayorService } from 'src/app/service/payor/payor.service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';

@Component({
  selector: 'app-trip-detail-model',
  templateUrl: './trip-detail-model.component.html',
  styleUrls: ['./trip-detail-model.component.css']
})
export class TripDetailModelComponent implements OnInit, OnDestroy {
  @Input('tripDetailModalObj') trip: any;
  @Input() source: any;
  @Input() corporatesByKey: any
  @ViewChild("AgmMap", { static: false }) agmElement: AgmMap;
  @Output() onCloseModal = new EventEmitter<string>();
  agmMap;
  bounds;
  latitude: number;
  longitude: number;
  zoom: number = 12;
  eta;
  contact;
  tripData: any;
  driverDetails;
  trackinURL;
  serviceAreas: any;
  payorList:any;
  prePayorsList: any = {};
  user;
  isAllowAuthorizationNumber = false;

  constructor(
    private sharedDataService: SharedDataService,
    private payorService: PayorService,
    private corporateService: CorporateService,
    private levelOfServiceService: LevelOfServiceService,
    private serviceArea: ServiceAreasService,
    private assignTripService: AssigTripsService,
    private kpisService: KpisService,
    private driverService: DriversService
   ) { }

  ngOnInit() {
    this.trackinURL = environment.TRACKING_URL;
    this.getUser();
    this.getTrips();
    this.getPayorList();
    if (this.source === "statistics") {
      this.getTripDetails();
    }
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          if (this.user.allowAuthorizationNumber) {
            this.isAllowAuthorizationNumber = this.user.allowAuthorizationNumber;
          } 
          else if (this.user.cooperate && this.user.cooperate.allowAuthorizationNumber) {
            this.isAllowAuthorizationNumber = this.user.cooperate.allowAuthorizationNumber;
          }
        }
      });
  }

  getTrips() {
    this.assignTripService
      .tripDetail(this.trip._id)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.tripData = data;
            // if (this.tripData.driver) {
            //   this.getDriverDetails(this.tripData.driver);
            // }
            if (data.priorityClient) {
              this.contact = data.priorityClient.contactNumber;
            }
            this.getConfigurations();
          }
        });
  }

  closeModal() {
    this.onCloseModal.emit();
  }

  getDriverDetails(id) {
    this.driverService
      .getDriverProfile(id)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.driverDetails = data;
        }
      });
  }

  getETA(tripId) {
    this.assignTripService
      .getETA(tripId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data && data.etaMessage) {
          this.eta = data.etaMessage;
        }
      });
  }

  sendSMS() {
    if (!this.contact) return;
    this.trip.contactNumber = this.contact;

    const payload = {
      ...this.trip,
      tripId: this.trip._id,
      latitude: this.trip.driver.latitude,
      longitude: this.trip.driver.longitude,
    }
    this.assignTripService
      .sendTrackingSMS(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          // this.contact = '';
          if (data.success) {
            sweetAlert('Success', data.message, 'success', 'OK');
          } else {
            sweetAlert('Error', data.message, 'error', 'OK');
          }
        }
      });
  }

  getTripDetails() {
    this.kpisService.getNemtStatsById(this.trip._id)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.trip = data;
        }
      })
  }

  getJobStatus(status) {
    let tripStatus = status;

    if (status === 'pending') {
      tripStatus = 'Unassigned';
    } else if (status === 'arrived') {
      tripStatus = 'On Scene';
    } else if (status === 'started') {
      tripStatus = 'Member Onboard';
    } else if (status === 'onway') {
      tripStatus = 'In Route';
    }

    return tripStatus
  }

  breakString(str) {
    if (!str) return "";
    return str.replace(/\n/g, "<br>");
  }


  getPayorTypeTitle(corporateId, payorType) {
    if (!this.corporatesByKey) return;

    let payor;
    let types = this.corporatesByKey[corporateId];
    if (types && types.length) {
      payor = types.find(t => t.value === payorType);
    }
    return payor ? payor.title : '';
  }

  getConfigurations() {
    this.assignTripService
      .getConfigurations({status: 'active'})
      .subscribe(data => {
        if (data) {
          if(data.levelofservices && data.levelofservices.length){
            this.tripData.los = data.levelofservices.find((item) => item._id === this.tripData.los);
            this.tripData.los = this.tripData.los ? this.tripData.los.title : 'N/A';
          }

          if(data.serviceareas && data.serviceareas.length){
            this.serviceAreas = data.serviceareas;
            const sArea = this.serviceAreas.find((item) => item._id === this.tripData.serviceArea);
            this.tripData.serviceArea = sArea ? sArea.name : 'N/A';
          }
          if(data.spacetypes && data.spacetypes.length){
            this.tripData.spaceType = data.spacetypes.find((item) => item._id === this.tripData.spaceType);
            this.tripData.spaceType = this.tripData.spaceType ? this.tripData.spaceType.title : 'N/A';
          }
          
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

   getPayorList() {

    const param = {
      status: 'active'
    };

    this.payorService
      .getPayorList(param)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data: any) => {
          if (data) {
            this.payorList = data;
            this.prePayorsList = this.payorList.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        },
        (err) => {
          sweetAlert('Error', err, 'warning', 'OK');
        }
      );
  }



  ngOnDestroy(): void {
  }
}
